import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModal from 'UIComponents/dialog/UIModal';
import H2 from 'UIComponents/elements/headings/H2';
import UIForm from 'UIComponents/form/UIForm';
import UIFormLabel from 'UIComponents/form/UIFormLabel';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import UITextArea from 'UIComponents/input/UITextArea';
import UILink from 'UIComponents/link/UILink';
import { useState } from 'react';
import { useSubscription } from '../../hooks/useSubscription';
import { TEST_IDS, URLS } from '../../utils/constants';
import { handleError } from '../../utils/errorHandling';
import { useTracker } from '../../utils/usageTracker';
import { usePauseSubscription } from './usePauseSubscription';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function PauseSubscriptionModal({
  objectId,
  actions
}) {
  var _buyer$email;
  const {
    close
  } = actions;
  const {
    trackInteraction
  } = useTracker();
  const {
    buyer,
    checkoutEmail
  } = useSubscription();
  const customerEmail = (_buyer$email = buyer === null || buyer === void 0 ? void 0 : buyer.email) !== null && _buyer$email !== void 0 ? _buyer$email : checkoutEmail;
  const [internalNotes, setInternalNotes] = useState('');
  const [onSubmit, {
    loading: submitLoading
  }] = usePauseSubscription({
    objectId,
    internalNotes,
    onClose: async () => {
      close();
      await actions.revalidate();
    }
  });
  return /*#__PURE__*/_jsx(UIModal, {
    "data-test-id": TEST_IDS.Pause,
    children: /*#__PURE__*/_jsxs(UIForm, {
      children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
        children: [/*#__PURE__*/_jsx(H2, {
          className: "p-y-4",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "subscriptions.PauseSubscriptionModal.title"
          })
        }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
          onClick: () => {
            trackInteraction('pauseSubscriptionModalClosed');
            close();
          }
        })]
      }), /*#__PURE__*/_jsxs(UIDialogBody, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "subscriptions.PauseSubscriptionModal.description"
        }), /*#__PURE__*/_jsx("div", {
          className: "m-y-3",
          children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "subscriptions.PauseSubscriptionModal.description_jsx",
            options: {
              email: customerEmail,
              href: URLS.KBPause,
              external: true
            },
            elements: {
              Link: UILink
            }
          })
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsxs(UIFormLabel, {
            className: "m-bottom-2",
            children: [/*#__PURE__*/_jsx(FormattedMessage, {
              message: "subscriptions.PauseSubscriptionModal.internalNotes.label",
              className: "m-right-1"
            }), /*#__PURE__*/_jsx(UIHelpIcon, {
              title: /*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
                  message: "subscriptions.PauseSubscriptionModal.internalNotes.tooltip"
                }), /*#__PURE__*/_jsx(FormattedJSXMessage, {
                  message: "subscriptions.PauseSubscriptionModal.internalNotes.tooltip_jsx",
                  options: {
                    href: URLS.KBPauseTooltip,
                    external: true
                  },
                  elements: {
                    Link: UILink
                  }
                })]
              }),
              tooltipPlacement: "right"
            })]
          }), /*#__PURE__*/_jsx(UITextArea, {
            rows: 4,
            placeholder: I18n.text('subscriptions.PauseSubscriptionModal.internalNotes.placeholder'),
            resize: false,
            onChange: ({
              currentTarget: {
                value
              }
            }) => {
              setInternalNotes(value);
            }
          })]
        })]
      }), /*#__PURE__*/_jsxs(UIDialogFooter, {
        children: [/*#__PURE__*/_jsx(UILoadingButton, {
          "data-test-id": `${TEST_IDS.Pause}:submit`,
          use: "primary",
          loading: submitLoading,
          onClick: () => {
            onSubmit().catch(e => handleError(e));
          },
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "subscriptions.PauseSubscriptionModal.pauseButton"
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          "data-test-id": `${TEST_IDS.Pause}:cancel`,
          use: "secondary",
          onClick: () => {
            trackInteraction('pauseSubscriptionModalClosed');
            close();
          },
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "subscriptions.PauseSubscriptionModal.cancelButton"
          })
        })]
      })]
    })
  });
}